var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInnovative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78,
    height: 71,
    viewBox: "0 0 78 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h77v70H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.56 .12)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DEE0FF",
    mask: "url(#b)",
    d: "M21 63h28v7H21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.96 63.91H20.01c-.4 0-.73-.22-.73-.5s.32-.51.73-.51h27.95c.4 0 .74.23.74.5 0 .29-.33.51-.74.51Z",
    fill: "#000",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2 70a.75.75 0 0 1-.75-.74V58.09h-4.11a6.35 6.35 0 0 1-6.36-6.33v-8.57H.75a.74.74 0 0 1-.68-1.05l5.92-13.26v-2.82A26.11 26.11 0 0 1 52.1 9.33c.27.31.23.78-.08 1.05a.75.75 0 0 1-1.06-.09 24.73 24.73 0 0 0-18.81-8.8h-.3A24.72 24.72 0 0 0 7.47 26.06v2.98c0 .1-.02.21-.06.3L1.9 41.7h7.83c.4 0 .74.34.74.75v9.3a4.86 4.86 0 0 0 4.87 4.85h4.86c.41 0 .75.33.75.74v11.17h26.93c.15-1.7-1.05-13.76 5.46-29.33a.75.75 0 0 1 1.39.57c-6.5 15.53-5.18 27.42-5.35 29.5 0 .42-.34.75-.75.75H20.2Z",
    fill: "#000",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.5 43.93c0 .6-.51 1.07-1.14 1.07H45.64c-.63 0-1.14-.48-1.14-1.07V39h13v4.93Z",
    stroke: "#000",
    fill: "#010ED0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 20.68c0 2.56-.94 5.03-2.66 6.97-3.49 3.94-2.85 8.6-2.85 9.35H45.51c0-.92.76-5.02-3.07-9.61a10.42 10.42 0 0 1-2.35-8.1A10.92 10.92 0 0 1 51 10C57.07 10 62 14.8 62 20.68Z",
    fill: "#DEE0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.01 37v1.5H58v-1.58l-.02-.5a10.65 10.65 0 0 1 2.23-7.47l.26-.3a12 12 0 0 0 3.04-7.97C63.5 13.95 57.88 8.5 51 8.5c-6.31 0-11.61 4.63-12.4 10.59-.42 3.24.46 6.42 2.46 8.98l.23.28c2.26 2.71 2.88 5.07 2.77 7.7l-.04.62V37ZM51 10c6.06 0 11 4.8 11 10.68 0 2.44-.86 4.8-2.43 6.7l-.23.27c-3.49 3.94-2.85 8.6-2.85 9.35h-5.05V25.73a1 1 0 0 1 .3-.72l4.98-4.83a.42.42 0 0 0 .06-.53l-.06-.08a.45.45 0 0 0-.63 0l-4.4 4.27a1 1 0 0 1-1.38 0l-4.4-4.27a.45.45 0 0 0-.63 0 .42.42 0 0 0-.06.54l.06.07 4.98 4.83c.19.19.3.45.3.72V37H45.5l.01-.27c.08-1.26.44-4.94-2.86-9.08l-.22-.26a10.42 10.42 0 0 1-2.35-8.1A10.92 10.92 0 0 1 51 10Z",
    fill: "#000",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.48 21.67h9.56c.44 0 .8-.23.8-.51s-.36-.5-.8-.5h-9.56c-.44 0-.8.22-.8.5s.36.5.8.5ZM66.22 13.15l4.02-4.02c.27-.27.34-.66.14-.86-.2-.2-.58-.13-.86.15l-4.02 4.01c-.28.28-.34.67-.14.86.2.2.58.14.86-.14ZM66.22 29.17l4.02 4.02c.27.27.34.66.14.86-.2.2-.58.13-.86-.15L65.5 29.9c-.28-.28-.34-.67-.14-.86.2-.2.58-.14.86.14Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovative);
export default __webpack_public_path__ + "static/media/Innovative.f0ac0df241911d7f6cc51d2063c3e738.svg";
export { ForwardRef as ReactComponent };